export const getAgentDisplayName = (agentName: string) => {
    const agentNameMap: Record<string, string> = {
        dynamic_form_agent: "Dynamic forms",
        qa_agent: "QA",
        qualification_agent: "Qualification",
        dynamic_form: "Dynamic forms",
        public_agent: "Public",
        supervisor: "Supervisor",
    }
    return agentNameMap[agentName] ?? agentName
}

export const getAgentColor = (agentName: string) => {
    const agentColorMap: Record<string, string> = {
        dynamic_form_agent: "rgba(156, 39, 176, 1)", // Purple
        qa_agent: "rgba(76, 175, 80, 1)", // Green
        qualification_agent: "rgba(255, 152, 0, 1)", // Orange
        dynamic_form: "rgba(233, 30, 99, 1)", // Pink
        public_agent: "rgba(0, 150, 136, 1)", // Teal
        supervisor: "rgba(121, 85, 72, 1)", // Brown
    }
    return agentColorMap[agentName] ?? "rgba(158, 158, 158, 1)" // Default gray
}
